import { Badge } from "@/components/ui/badge";
import { Users, DollarSign } from "lucide-react";

/**
 * Preview grid — recipient count, GHL synced count, segments/msg, est cost —
 * plus sample recipient badges. Returns null when no preview exists yet.
 */
export function PreviewPanel({ preview }) {
  if (!preview) return null;
  return (
    <div data-testid="sms-broadcast-preview-panel"
         className="rounded-lg border border-white/10 bg-white/[0.02] p-4 space-y-3">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <div>
          <div className="text-[10px] uppercase tracking-widest text-zinc-500 flex items-center gap-1">
            <Users className="h-3 w-3" /> Recipients
          </div>
          <div className="text-xl font-semibold" data-testid="sms-broadcast-recipient-count">
            {preview.recipient_count}
          </div>
        </div>
        <div>
          <div className="text-[10px] uppercase tracking-widest text-zinc-500">GHL synced</div>
          <div className="text-xl font-semibold text-emerald-300">{preview.matched_ghl_count}</div>
        </div>
        <div>
          <div className="text-[10px] uppercase tracking-widest text-zinc-500">Segments/msg</div>
          <div className="text-xl font-semibold">{preview.segments_per_message}</div>
        </div>
        <div>
          <div className="text-[10px] uppercase tracking-widest text-zinc-500 flex items-center gap-1">
            <DollarSign className="h-3 w-3" /> Est cost
          </div>
          <div className="text-xl font-semibold text-amber-300" data-testid="sms-broadcast-est-cost">
            ${preview.estimated_cost_usd.toFixed(2)}
          </div>
        </div>
      </div>
      <div className="text-[11px] text-zinc-500">{preview.cost_note}</div>
      {preview.unmatched_count > 0 && (
        <div className="text-[11px] text-amber-400" data-testid="sms-broadcast-unmatched-warning">
          {preview.unmatched_count} recipient(s) don&apos;t have a GHL contact yet — they&apos;ll be lazy-synced on send.
        </div>
      )}
      {preview.sample_recipients?.length > 0 && (
        <div className="flex flex-wrap gap-1.5">
          {preview.sample_recipients.map((r) => (
            <Badge key={r.id} variant="outline"
                   className={`text-[10px] ${r.has_ghl_contact ? "border-emerald-500/30 text-emerald-300" : "border-amber-500/30 text-amber-300"}`}>
              {r.name} · •••{r.phone_last4}
            </Badge>
          ))}
          {preview.recipient_count > preview.sample_recipients.length && (
            <span className="text-[10px] text-zinc-500 py-0.5">
              +{preview.recipient_count - preview.sample_recipients.length} more
            </span>
          )}
        </div>
      )}
    </div>
  );
}
